export default {
  title: {
    en: 'Skip a month',
  },
}
